/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Already_Own_A_Domain_ConnectInputs */

const en_already_own_a_domain_connect = /** @type {(inputs: Already_Own_A_Domain_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already own a domain? Connect it here.`)
};

const es_already_own_a_domain_connect = /** @type {(inputs: Already_Own_A_Domain_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Ya tienes un dominio? Conéctalo aquí.`)
};

const fr_already_own_a_domain_connect = /** @type {(inputs: Already_Own_A_Domain_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous possédez déjà un domaine ? Connectez-le ici.`)
};

const de_already_own_a_domain_connect = /** @type {(inputs: Already_Own_A_Domain_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du besitzt bereits eine Domain? Verbinde sie hier.`)
};

const ja_already_own_a_domain_connect = /** @type {(inputs: Already_Own_A_Domain_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すでにドメインをお持ちですか？こちらから接続してください。`)
};

const zh_already_own_a_domain_connect = /** @type {(inputs: Already_Own_A_Domain_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已拥有域名？在此连接。`)
};

const ar_already_own_a_domain_connect = /** @type {(inputs: Already_Own_A_Domain_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تملك نطاقاً بالفعل؟ اربطه من هنا.`)
};

const id_already_own_a_domain_connect = /** @type {(inputs: Already_Own_A_Domain_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah punya domain? Hubungkan di sini.`)
};

const it_already_own_a_domain_connect = /** @type {(inputs: Already_Own_A_Domain_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Possiedi già un dominio? Collegalo qui.`)
};

const ru_already_own_a_domain_connect = /** @type {(inputs: Already_Own_A_Domain_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уже есть домен? Подключите его здесь.`)
};

const pt_already_own_a_domain_connect = /** @type {(inputs: Already_Own_A_Domain_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já tem um domínio? Conecte-o aqui.`)
};

const ko_already_own_a_domain_connect = /** @type {(inputs: Already_Own_A_Domain_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 도메인을 소유하고 계신가요? 여기서 연결하세요.`)
};

/**
* | output |
* | --- |
* | "Already own a domain? Connect it here." |
*
* @param {Already_Own_A_Domain_ConnectInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const already_own_a_domain_connect = /** @type {((inputs?: Already_Own_A_Domain_ConnectInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Already_Own_A_Domain_ConnectInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_already_own_a_domain_connect(inputs)
	if (locale === "es") return es_already_own_a_domain_connect(inputs)
	if (locale === "fr") return fr_already_own_a_domain_connect(inputs)
	if (locale === "de") return de_already_own_a_domain_connect(inputs)
	if (locale === "ja") return ja_already_own_a_domain_connect(inputs)
	if (locale === "zh") return zh_already_own_a_domain_connect(inputs)
	if (locale === "ar") return ar_already_own_a_domain_connect(inputs)
	if (locale === "id") return id_already_own_a_domain_connect(inputs)
	if (locale === "it") return it_already_own_a_domain_connect(inputs)
	if (locale === "ru") return ru_already_own_a_domain_connect(inputs)
	if (locale === "pt") return pt_already_own_a_domain_connect(inputs)
	return ko_already_own_a_domain_connect(inputs)
});